import { Suspense } from "react";

import { MapPanel } from "~/modules/map/components/MapPanel";

import { MapEditorFeatureOtherPanelContent } from "./MapEditorFeatureOtherPanelContent";
import { MapEditorFeatureOtherPanelSkeleton } from "./MapEditorFeatureOtherPanelSkeleton";

export interface MapEditorFeatureOtherPanelProps {
    backHref: string;
    mapEditorFeatureId: string;
    readonly: boolean;
    title: string;
}

export function MapEditorFeatureOtherPanel({ backHref, mapEditorFeatureId, readonly, title }: MapEditorFeatureOtherPanelProps) {
    return (
        <MapPanel>
            <Suspense key={mapEditorFeatureId} fallback={<MapEditorFeatureOtherPanelSkeleton />}>
                <MapEditorFeatureOtherPanelContent
                    backHref={backHref}
                    mapEditorFeatureId={mapEditorFeatureId}
                    readonly={readonly}
                    title={title}
                />
            </Suspense>
        </MapPanel>
    );
}
